// @flow
import appstore_textbook from '../molecules/app-menu/assets/appstore-textbook.png'
import google_textbook from '../molecules/app-menu/assets/google-textbook.png'

export const APP_STORE_APPS = [
  {
    link: 'https://redirect.appmetrica.yandex.com/serve/385228509095679766',
    text: 'Фоксфорд <br />Учебник',
    operatingSystem: 'Ios',
    applicationCategory: 'Education',
    icon: appstore_textbook,
  },
]

export const GOOGLE_PLAY_APPS = [
  {
    link: 'https://redirect.appmetrica.yandex.com/serve/889631661438820921',
    text: 'Фоксфорд <br />Учебник',
    operatingSystem: 'Android',
    applicationCategory: 'Education',
    icon: google_textbook,
  },
]
